import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=307277ee&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=307277ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307277ee",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/PurchaseOrderTracking/OrderDetails.vue
// module id = 2333
// module chunks = 31